import { InputAdornment, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';

export type AccountFilterValue =
	| { type: 'all' }
	| { type: 'accountId'; value: string }
	| { type: 'subscriptionName'; value: string };

type Props = {
	filter: AccountFilterValue;
	onChange: (value: AccountFilterValue) => void;
};

export const AccountFilter = ({ filter, onChange }: Props) => {
	const renderFilterInput = () => {
		switch (filter.type) {
			case 'accountId':
				return (
					<NumericFormat
						customInput={TextField}
						label='Account ID'
						value={filter.value}
						onValueChange={({ value }) => {
							onChange({
								type: 'accountId',
								value,
							});
						}}
						decimalScale={0}
						allowNegative={false}
						fullWidth
						InputProps={{
							startAdornment: <InputAdornment position='start'>AC-</InputAdornment>,
						}}
					/>
				);
			case 'subscriptionName':
				return (
					<TextField
						label='Subscription Name'
						value={filter.value}
						onChange={(event) => {
							onChange({
								type: 'subscriptionName',
								value: event.target.value,
							});
						}}
						fullWidth
					/>
				);
			default:
				return null;
		}
	};

	const handleTypeChange = (_: unknown, type: AccountFilterValue['type'] | null) => {
		switch (type) {
			case 'all':
				onChange({ type: 'all' });
				break;
			case 'accountId':
				onChange({ type: 'accountId', value: '' });
				break;
			case 'subscriptionName':
				onChange({ type: 'subscriptionName', value: '' });
				break;
			default:
				return;
		}
	};

	return (
		<Stack spacing={2}>
			<Typography variant='subtitle1' fontWeight={600}>
				Account filter
			</Typography>
			<ToggleButtonGroup exclusive value={filter.type} onChange={handleTypeChange} size='small'>
				<ToggleButton value='all'>All accounts</ToggleButton>
				<ToggleButton value='accountId'>Account ID</ToggleButton>
				<ToggleButton value='subscriptionName'>Subscription name</ToggleButton>
			</ToggleButtonGroup>

			{renderFilterInput()}
		</Stack>
	);
};
